import { render, staticRenderFns } from "./saleOrderDispatchItems.vue?vue&type=template&id=c168c572"
import script from "./saleOrderDispatchItems.vue?vue&type=script&lang=js"
export * from "./saleOrderDispatchItems.vue?vue&type=script&lang=js"
import style0 from "./saleOrderDispatchItems.vue?vue&type=style&index=0&id=c168c572&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports